import { gql } from '@apollo/client'

export const JoinRoom = gql`
    mutation JoinRoom($roomId: ID!) {
        joinRoom(roomId: $roomId) {
            id
            updated
            room {
                id
                name
                topic
                public
                owner {
                    id
                    username
                }
                members {
                    id
                    username
                }
            }
            actor {
                id
                username
                rooms {
                    id
                    name
                    topic
                    public
                    owner {
                        id
                        username
                    }
                    members {
                        id
                        username
                    }
                }
            }
        }
    }
`

export default JoinRoom

